export default __webpack_public_path__ + "static/media/TJQRCode.64729269.jpg";